import { render, staticRenderFns } from "./Servernenu.vue?vue&type=template&id=82329048"
import script from "./Servernenu.vue?vue&type=script&lang=js"
export * from "./Servernenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports